export default __webpack_public_path__ + "static/media/icons-vendor-management.6674e8aa.svg";